if (!customElements.get('card-variant-picker')) {
  class CardVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.productData = null;
      this.selectedVariant = null;
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      console.log("This @ card-variant-picker >> ", this);

    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;

      this.radios = this.querySelectorAll('.card-variant__radio');
      this.priceContainer = this.querySelector('[data-card-variant-price]');
      this.variantIdInput = this.querySelector('[data-card-variant-id]');
      this.addText = this.querySelector('[data-card-variant-add-text]');
      this.form = this.querySelector('form');

      // Prefer cart-drawer for sections (static IDs), fallback to cart-notification
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartNotification = document.querySelector('cart-notification');
      this.cart = this.cartDrawer || this.cartNotification;

      // Read product data from embedded JSON
      const jsonEl = this.querySelector('[data-card-variant-json]');
      if (jsonEl) {
        try {
          this.productData = JSON.parse(jsonEl.textContent);
        } catch (e) {
          console.error('Failed to parse variant JSON:', e);
        }
      }

      this.addEventListener('change', (event) => {
        if (event.target.classList.contains('card-variant__radio')) {
          event.stopPropagation();
          this.onVariantChange(event);
        }
      });

      if (this.form) {
        this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      }
    }

    onVariantChange(event) {
      console.log("Variant CHange Trigger...")

      const selectedValue = event.target.value;

      if (!this.productData) return;

      const variants = this.productData.variants || [];
      const matchedVariant = variants.find(
        (v) => String(v.option1) === String(selectedValue)
      );

      if (matchedVariant) {
        this.selectedVariant = matchedVariant;
        this.updatePrice(matchedVariant);
        this.updateVariantId(matchedVariant);
        this.updateAddButton(matchedVariant);
      }
    }

    updatePrice(variant) {
      if (!this.priceContainer) return;

      const showDecimals = this.dataset.showDecimals === 'true';

      const formatMoney = (cents) => {
        const amount = showDecimals ? (cents / 100).toFixed(2) : Math.round(cents / 100);
        return `₹${amount}`;
      };

      let priceHtml = '';

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml += `<s class="card-variant__compare-price">${formatMoney(variant.compare_at_price)}</s> `;
      }

      priceHtml += `<span class="card-variant__current-price">${formatMoney(variant.price)}</span>`;

      this.priceContainer.innerHTML = priceHtml;
    }

    updateVariantId(variant) {
      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
        this.variantIdInput.disabled = false;
      }
    }

    updateAddButton(variant) {
      if (!this.addText) return;

      const submitBtn = this.querySelector('.card-variant__submit');
      const soldOutMsg = this.querySelector('.sold-out-message');

      if (variant.available) {
        this.addText.textContent = 'Add to cart';
        this.addText.classList.remove('hidden');
        if (soldOutMsg) soldOutMsg.classList.add('hidden');
        if (submitBtn) submitBtn.disabled = false;
      } else {
        this.addText.textContent = 'Sold out';
        this.addText.classList.add('hidden');
        if (soldOutMsg) soldOutMsg.classList.remove('hidden');
        if (submitBtn) submitBtn.disabled = true;
      }
    }

    async onFormSubmit(event) {
      event.preventDefault();

      const submitBtn = this.querySelector('.card-variant__submit');
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
      }

      const formData = new FormData(this.form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;

      // Dispatch cart lines update event for analytics (like product-form.js)
      const { CartLinesUpdateEvent } = window.StandardEvents || {};
      let linesUpdateDeferred = null;
      if (CartLinesUpdateEvent) {
        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        linesUpdateDeferred = deferred;
      }

      // Add sections for cart drawer/notification (like product-form.js)
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(document.activeElement);
        }
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const result = await response.json();

        if (response.ok && !result.status) {
          // Resolve cart lines update promise
          if (linesUpdateDeferred) {
            const { CartLinesUpdateEvent } = window.StandardEvents || {};
            if (CartLinesUpdateEvent) {
              const pendingCartDataPromise = typeof CartItems !== 'undefined'
                ? CartItems.fetchCartData()
                : fetch(`${routes.cart_url}.json`).then((r) => r.json());

              pendingCartDataPromise
                .then((cartData) => {
                  if (!cartData?.currency) return linesUpdateDeferred.reject(new Error('Missing currency in cart response'));
                  linesUpdateDeferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartData) });
                })
                .catch((e) => linesUpdateDeferred.reject(e));
            }
          }

          // Publish cart update event for pub/sub (like product-form.js)
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-variant-picker',
              productVariantId: variantId,
              cartData: result,
            });
          }

          // Render updated cart contents (like product-form.js)
          if (cart) {
            if (cart.classList.contains('is-empty')) {
              cart.classList.remove('is-empty');
            }
            cart.renderContents(result);
          }

          // Also dispatch standard events for backward compatibility
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { variant: result },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:drawer:open', {
              bubbles: true,
            })
          );
        } else {
          // Handle error
          const errorMessage = result.description || result.message || 'Error adding to cart';

          if (linesUpdateDeferred) {
            linesUpdateDeferred.reject(new Error(errorMessage));
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-variant-picker',
              productVariantId: variantId,
              errors: result.errors || result.description,
              message: result.message,
            });
          }

          if (submitBtn) {
            const soldOutMessage = submitBtn.querySelector('.sold-out-message');
            if (soldOutMessage) {
              submitBtn.setAttribute('aria-disabled', 'true');
              this.addText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
          }
        }
      } catch (error) {
        console.error('Failed to add to cart:', error);
        if (linesUpdateDeferred) {
          linesUpdateDeferred.reject(error);
        }
      } finally {
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
          this.showAddedSuccess(submitBtn);
        }
      }
    }

    showAddedSuccess(submitBtn) {
      if (!submitBtn || submitBtn.classList.contains('is-added')) return;
      const originalText = this.addText ? this.addText.innerHTML : submitBtn.innerHTML;

      submitBtn.classList.add('is-added');
      if (this.addText) {
        this.addText.innerHTML = `
          <span class="atc-success-content">
            <svg class="atc-checkmark-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>Added!</span>
          </span>
        `;
      }

      // Header Cart Count Bounce
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.classList.remove('cart-bounce-animate');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('cart-bounce-animate');
        setTimeout(() => cartIcon.classList.remove('cart-bounce-animate'), 1000);
      }

      setTimeout(() => {
        submitBtn.classList.remove('is-added');
        if (this.addText) {
          this.addText.innerHTML = originalText;
        }
      }, 2200);
    }
  }

  customElements.define('card-variant-picker', CardVariantPicker);
}